// ISO country → flag emoji + ISO code helper.
const COUNTRY_MAP = {
    "Türkiye": { code: "TR", flag: "🇹🇷" },
    "Turkey": { code: "TR", flag: "🇹🇷" },
    "Romania": { code: "RO", flag: "🇷🇴" },
    "Romanya": { code: "RO", flag: "🇷🇴" },
    "România": { code: "RO", flag: "🇷🇴" },
    "Italy": { code: "IT", flag: "🇮🇹" },
    "İtalya": { code: "IT", flag: "🇮🇹" },
    "Italia": { code: "IT", flag: "🇮🇹" },
    "Republic of Moldova": { code: "MD", flag: "🇲🇩" },
    "Moldova": { code: "MD", flag: "🇲🇩" },
    "Moldova Cumhuriyeti": { code: "MD", flag: "🇲🇩" },
    "Republica Moldova": { code: "MD", flag: "🇲🇩" },
    "Georgia": { code: "GE", flag: "🇬🇪" },
    "Gürcistan": { code: "GE", flag: "🇬🇪" },
    "Lithuania": { code: "LT", flag: "🇱🇹" },
    "Litvanya": { code: "LT", flag: "🇱🇹" },
    "Bosnia and Herzegovina": { code: "BA", flag: "🇧🇦" },
    "Bosna-Hersek": { code: "BA", flag: "🇧🇦" },
    "Multiple": { code: "EU", flag: "🇪🇺" },
};

export function getCountryFlag(country) {
    return COUNTRY_MAP[country]?.flag || "🌍";
}

export function getCountryCode(country) {
    return COUNTRY_MAP[country]?.code || "—";
}

export default function CountryFlag({ country, size = "sm", showCode = false, className = "" }) {
    const flag = getCountryFlag(country);
    const code = getCountryCode(country);
    const sizes = {
        xs: "text-sm",
        sm: "text-base",
        md: "text-xl",
        lg: "text-2xl",
        xl: "text-4xl",
    };
    return (
        <span
            className={`inline-flex items-center gap-1.5 ${className}`}
            data-testid={`country-flag-${code.toLowerCase()}`}
            title={country}
        >
            <span className={`${sizes[size]} leading-none`} aria-hidden="true">
                {flag}
            </span>
            {showCode && (
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-muted">
                    {code}
                </span>
            )}
        </span>
    );
}
